"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISerializedScenarioAnalysisResultSchema = exports.ISerializedBoundaryScenarioSchema = exports.ISerializedBoundaryRoleAssignmentSchema = void 0;
const zod_1 = require("zod");
const BoundaryAnalysisMode_1 = require("../BoundaryAnalysisMode");
const SignalId_1 = require("../DesignModels/SignalId");
const BoundaryCharacteristicStateSerialized_1 = require("./BoundaryCharacteristicStateSerialized");
exports.ISerializedBoundaryRoleAssignmentSchema = zod_1.default.object({
    boundaryId: zod_1.default.string(),
    signalId: SignalId_1.SignalIdSchema,
});
exports.ISerializedBoundaryScenarioSchema = zod_1.default.object({
    drivers: exports.ISerializedBoundaryRoleAssignmentSchema.array(),
    acceptors: exports.ISerializedBoundaryRoleAssignmentSchema.array(),
    result: BoundaryCharacteristicStateSerialized_1.BoundaryCharacteristicStateSerializedSchema.array(),
});
exports.ISerializedScenarioAnalysisResultSchema = zod_1.default.object({
    mode: BoundaryAnalysisMode_1.BoundaryAnalysisModeSchema,
    scenarios: exports.ISerializedBoundaryScenarioSchema.array(),
    bestScenarioPerCharacteristic: zod_1.default.record(zod_1.default.string(), zod_1.default.number()),
});
//# sourceMappingURL=ISerializedBoundaryScenario.js.map